import { render, staticRenderFns } from "./ResourceActions.vue?vue&type=template&id=09e6c01b&"
import script from "./ResourceActions.vue?vue&type=script&lang=js&"
export * from "./ResourceActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports